/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import Share from './share';
import get from 'lodash/get';
import './share-floating-expanded.m.css';
import SvgIcon from '../../atoms/svg-icon';
import BookmarkShare from './bookmark-share';
import { useSelector } from 'react-redux';

const ShareFloatingExpanded = (props) => {
  const Template = ({ services, socialShareConfig, datalayerFields, onClick }) => {
    const onClickService = (event, service) => {
      socialShareConfig[service].func ? socialShareConfig[service].func(event) : onClick(event);
      trackUserInteraction(
        Object.assign({}, datalayerFields, {
          category: 'social media',
          action: service,
          cd22: 'logo',
          cd23: 'middle share module container',
        })
      );
    };

    return (
      <ul styleName="social-list">
        {services.map((service, index) => (
          <li key={index}>
            <a
              target="_blank"
              data-social-media-type={service}
              href={socialShareConfig[service].url}
              rel="noopener noreferrer nofollow"
              data-social-media-share-url={socialShareConfig[service].url}
              data-component-type="share"
              data-track-click={service}
              className={`icon-ic_${service}`}
              onClick={(event) => onClickService(event, service)}
            ></a>
            <span styleName="social-title">
              {socialShareConfig[service].title === 'Twitter'
                ? 'X (was Twitter)'
                : socialShareConfig[service].title}
            </span>
          </li>
        ))}
      </ul>
    );
  };
  const independence = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'independence_day'], false)
  );

  const getDisplayName = () => {
    let displayName = '';
    if (Array.isArray(props?.story?.sections)) {
      for (let i = 0; i < props?.story?.sections?.length; i++) {
        const section = props?.story?.sections[i];
        if ('display-name' in section) {
          displayName = section['display-name'];
          break;
        }
      }
    }
    return displayName;
  };

  return (
    <div styleName={`share-floating-expanded show ${independence?.active ? 'increase-bar' : ''}`}>
      <div styleName="sidebar" className="container">
        <div styleName="breadcrumb" className="desktop-only">
          <span>{getDisplayName()}</span>
          <span styleName="dot"></span>
          <span styleName="breadcrumb-headline">{get(props, ['story', 'headline'], '')}</span>
        </div>
        <div styleName="shareIcon-mobile" className="mobile-only">
          <SvgIcon type="share-icon-red" source="image" />
          <span>Share</span>
        </div>
        <div styleName="share-wrapper">
          <div styleName="share-wrapper-ctx">
            <Share
              template={Template}
              expanded={true}
              alignType="horizontal"
              showToggleWhenExpanded={false}
              publisherUrl={props.publisherUrl}
              url={props.story.slug}
              title={props.story.headline}
              services={['whatsapp', 'twitter', 'facebook', 'telegram', 'copy']}
            />
            {props.bookmark && (
              <div styleName="bookmark-floating">
                <BookmarkShare />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareFloatingExpanded;
